import { render, staticRenderFns } from "./AdminImportOwnedVehicles.vue?vue&type=template&id=0632d15c&scoped=true&"
import script from "./AdminImportOwnedVehicles.vue?vue&type=script&lang=js&"
export * from "./AdminImportOwnedVehicles.vue?vue&type=script&lang=js&"
import style0 from "./AdminImportOwnedVehicles.vue?vue&type=style&index=0&id=0632d15c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0632d15c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0632d15c')) {
      api.createRecord('0632d15c', component.options)
    } else {
      api.reload('0632d15c', component.options)
    }
    module.hot.accept("./AdminImportOwnedVehicles.vue?vue&type=template&id=0632d15c&scoped=true&", function () {
      api.rerender('0632d15c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AdminImportOwnedVehicles.vue"
export default component.exports